import React from "react";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { string, array, bool, object, number } from "prop-types";

import { getHeadline, checkCurrentStoryTagForSpecialCampaign } from "../../utils/utils";

import NewsHeadline from "../../atoms/NewsHeadline";
import CardImage from "../../atoms/CardImage";
import LiveNewsHeadline from "../../atoms/liveNewsHeadline";
import SponsorDetails from "../SponsorDetails";

const NewsWithImage = ({
  story,
  showHeroImage = true,
  aspectRatio = [3, 2],
  imageType = "image3x2",
  widths = [250, 480, 764],
  darkTheme = false,
  largeIcon = false,
  showDot = false,
  styles = {},
  showSubHeading = true,
  sectionData,
  showSectionTag,
  datatrackinglabelpos,
  selectedTagName = "",
  headlineSpecialColor = "",
}) => {
  const { subheadline } = story;
  const storyHeadline = getHeadline(story);
  const currentStoryTitleColor = checkCurrentStoryTagForSpecialCampaign(story, selectedTagName, headlineSpecialColor);
  const sponsorId = get(story, ["metadata", "story-attributes", "sponsoredby", "0", "id"], null);
  const showLiveBlog = story["story-template"] === "live-blog";

  return (
    <div className="news_with_item">
      {showHeroImage && (
        <Link href={story.url}>
          <CardImage
            story={story}
            aspectRatio={aspectRatio}
            imageType={imageType}
            widths={widths}
            showAlternateImage={true}
            darkTheme={darkTheme}
            largeIcon={largeIcon}
            datatrackingcategory="Component One"
            datatrackingaction="Click"
            datatrackinglabel={`Position-${datatrackinglabelpos}`}
            datatrackingsubcategory="Component One Story Click"
          />
        </Link>
      )}
      {showLiveBlog ? (
        <LiveNewsHeadline
          titleText={storyHeadline}
          titleLink={story.url}
          story={story}
          cssStyleName="mediumSize"
          showDot={showDot}
          styles={styles}
          datatrackingcategory="Component One"
          datatrackingaction="Click"
          datatrackinglabel={`Position-${datatrackinglabelpos}`}
          datatrackingsubcategory="Component One Story Click"
        />
      ) : (
        <NewsHeadline
          story={story}
          titleText={storyHeadline}
          titleLink={story.url}
          subHeadlineText={subheadline}
          cssStyleName="mediumSize"
          sectionData={sectionData}
          showSectionTag={showSectionTag}
          showDot={showDot}
          styles={styles}
          showSubHeading={showSubHeading}
          datatrackingcategory="Component One"
          datatrackingaction="Click"
          datatrackinglabel={`Position-${datatrackinglabelpos}`}
          datatrackingsubcategory="Component One Story Click"
          currentStoryTitleColor={currentStoryTitleColor}
        />
      )}

      {sponsorId && <SponsorDetails sponsorId={sponsorId} showImage={false} />}
    </div>
  );
};

NewsWithImage.propTypes = {
  story: object.isRequired,
  showHeroImage: bool,
  aspectRatio: array,
  imageType: string,
  widths: array,
  darkTheme: bool,
  largeIcon: bool,
  showDot: bool,
  styles: object,
  showSubHeading: bool,
  sectionData: object,
  showSectionTag: bool,
  datatrackinglabelpos: number,
  selectedTagName: string,
  headlineSpecialColor: string,
};

export default NewsWithImage;
